import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Header } from 'semantic-ui-react';
import i18next from 'i18next';
import { fetchCompanyOrders, notifyOnOrderArrival } from '../../../actions';
import { formatPrice } from '../../../helpers/format';

class Orders extends Component {
    componentWillMount() {
        if (this.props.company.id) {
            this.props.fetchCompanyOrders(this.props.company.id);
        }
    }

    renderOrderDetails(order) {
        if (order.parts) {
            return order.parts.map(({ name, phone, items }, index) => {
                return (
                    <div key={index}>
                        <b>{`${name}, ${phone}`}</b>
                        {items.map((item, i) =>
                            <div key={i}>
                                {`${item.name} ${item.toppings.length ? `(${item.toppings.map(top => top.name).join(', ')})` : ''}`}
                            </div>)
                        }
                    </div>
                );
            });
        }

        const itemsByUser = order.items.reduce((items, item) => {
            if (!items[item.belongTo]) {
                items[item.belongTo] = [];
            }

            items[item.belongTo].push(item);
            return items;
        }, {});

        return Object.keys(itemsByUser).map((user, index) => {
            return (
                <div key={index}>
                    <b>{user}</b>
                    {itemsByUser[user].map((item) =>
                        <div key={item.id}>
                            {`${item.name} ${item.toppings.length ? `(${item.toppings.map(top => top.name).join(', ')})` : ''}`}
                        </div>)
                    }
                </div>
            );
        });
    }

    render() {
        return (
            <div style={{ padding: 10 }}>
                <Button
                    content={i18next.t('refresh')}
                    icon='refresh'
                    onClick={() => this.props.fetchCompanyOrders(this.props.company.id)}
                    basic
                />

                <Header>{i18next.t('orders.onGoingOrders')}</Header>

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine>{i18next.t('restaurant')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('order')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('minimum')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('total')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.timedOrders.filter(order => order.parts.length).map((order) => {
                            return (
                                <Table.Row key={order.groupId} positive negative={order.minimumOrderPrice > order.orderTotal}>
                                    <Table.Cell>{order.restaurant.name}</Table.Cell>
                                    <Table.Cell>
                                        {this.renderOrderDetails(order)}
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        {formatPrice(order.minimumOrderPrice, order.currencyCode, 2)}
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        {formatPrice(order.orderTotal, order.currencyCode, 2)}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>

                <Header>{i18next.t('orders.completedOrders')}</Header>

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>{'#'}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('restaurant')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('order')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('total')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('actions')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.completedOrders.map((order) => {
                            return (
                                <Table.Row key={order.id}>
                                    <Table.Cell collapsing>{order.id}</Table.Cell>
                                    <Table.Cell>{order.restaurant.name}</Table.Cell>
                                    <Table.Cell>
                                        {this.renderOrderDetails(order)}
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        {formatPrice(order.payments.reduce((total, { amount }) => total + amount, 0), order.currencyCode, 2)}
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Button
                                            circular
                                            size='tiny'
                                            icon='bullhorn'
                                            primary
                                            onClick={() => this.props.notifyOnOrderArrival(this.props.company.id, order.id)}
                                        />
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

Orders.propTypes = {
    company: PropTypes.object,
    completedOrders: PropTypes.array,
    timedOrders: PropTypes.array,
    fetchCompanyOrders: PropTypes.func,
    notifyOnOrderArrival: PropTypes.func
    
};

const mapStateToProps = (state) => {
    const { completedOrders, timedOrders } = state.budgetsApp.orders;

    return { completedOrders, timedOrders };
};

export default connect(mapStateToProps, { fetchCompanyOrders, notifyOnOrderArrival })(Orders);
